import { render, staticRenderFns } from "./offlineRecord.vue?vue&type=template&id=6bfd2a56"
import script from "./offlineRecord.vue?vue&type=script&lang=js"
export * from "./offlineRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports